var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13.125,
    viewBox: "0 0 15 13.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 33225",
    d: "M4.688 43.25H2.813a.938.938 0 0 1-.938-.938v-7.5a.938.938 0 0 1 .938-.938h1.875a.938.938 0 1 0 0-1.875H2.813A2.813 2.813 0 0 0 0 34.813v7.5a2.813 2.813 0 0 0 2.813 2.813h1.875a.938.938 0 0 0 0-1.875zm10.037-5.35-3.75-3.75a.937.937 0 1 0-1.326 1.326l2.151 2.149H5.625a.938.938 0 0 0 0 1.875H11.8l-2.15 2.15a.937.937 0 0 0 1.326 1.326l3.75-3.75a.938.938 0 0 0-.001-1.326z",
    transform: "translate(0 -32)",
    style: {
      fill: "#4a4650"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d13564731daa1773684117114205fe26.svg";
export { ForwardRef as ReactComponent };